var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.browserSupportsAnimatedSVG)?_c('img',{style:(_vm.style),attrs:{"src":(_vm.$baseUrl + "img/loading_animated.svg")}}):_c('img',{staticClass:"icon-spin",style:(_vm.style),attrs:{"src":(_vm.$baseUrl + "img/loading.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }